import { RouteObject, useRoutes } from 'react-router';

import './style/antd-layers.css';
import './style/index.less';

type Props = {
  routes: RouteObject[];
};

export default ({ routes }: Props) => useRoutes(routes);
